// @flow

import updatePaymentMethod from './updatePaymentMethod'
import getCurrencyRate from './getCurrencyRate'

export default [
  ...updatePaymentMethod,
  ...getCurrencyRate,
]
